import React, { FC, FormEvent } from "react";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";

import {
  useInput,
  useDropdown,
  useProvidersCurrentEmployee,
  useApisManagersBusinessSectionsNew,
  useApisManagersBusinessSectionsCreate,
} from "~/hooks";

import type { ResponseMessageType } from "~/domains";

import {
  Form,
  FormSubmitButton,
  LabelWithTextField,
  LabelWithDropDownField,
} from "~/ui";

export const BusinessSectionNewForm: FC = () => {
  const navigate = useNavigate();
  const { refetch } = useProvidersCurrentEmployee();

  const { mutate: postBusinessSection, isLoading: isSubmitting } =
    useApisManagersBusinessSectionsCreate();

  const [
    { value: businessSectionName, onChange: onChangeBusinessSectionName },
  ] = useInput("");

  const [
    {
      dropdownValue: selectedBusinessDivision,
      onChange: onChangeBusinessDivision,
      handleSetSelectableOption: handleSetSelectableOption,
      dropdownSelectableValue: selectableBusinessDivisions,
    },
  ] = useDropdown();

  useApisManagersBusinessSectionsNew({
    config: {
      onSuccess: (data) => {
        handleSetSelectableOption(data.selectableBusinessDivisions);
      },
    },
  });

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const body = {
      name: businessSectionName,
      businessDivisionId: selectedBusinessDivision?.value || "",
    };
    postBusinessSection(
      {
        body,
      },
      {
        onSuccess: (data: ResponseMessageType) => {
          navigate("/managers/business_sections");
          toast(data?.message);
          refetch();
        },
      },
    );
  };

  return (
    <Form onSubmit={handleSubmit} className="space-y-6">
      <LabelWithTextField
        labelText="課名"
        type="text"
        name="businessSection"
        required
        placeholder="課名"
        value={businessSectionName}
        onChange={onChangeBusinessSectionName}
      />
      <LabelWithDropDownField
        labelText="部署"
        required
        name="businessDivisions"
        options={selectableBusinessDivisions}
        value={selectedBusinessDivision}
        onChange={onChangeBusinessDivision}
      />
      <FormSubmitButton
        color="primary"
        value="保存"
        className="w-full"
        isReadOnly={isSubmitting}
      />
    </Form>
  );
};
